export function formatDeliveryAddress(street, city, state, zip) {
  const line1 = street?.trim();
  const town = city?.trim();
  const region = state?.trim().toUpperCase();
  const postal = zip?.trim();
  if (!line1 || !town || !region || !postal) return '';
  return `${line1}, ${town}, ${region} ${postal}`;
}

export function isDeliveryAddressComplete(street, city, state, zip) {
  return (
    street?.trim().length >= 3 &&
    city?.trim().length >= 2 &&
    /^[A-Za-z]{2}$/.test(state?.trim() || '') &&
    /^\d{5}(-\d{4})?$/.test(zip?.trim() || '')
  );
}
